import { styled } from "goober";
import { config } from "../../environment";
import { isAdminViewUrl } from "../../lib/adminViewUrls";
import { apiUrl } from "../../lib/tenantOrigin";
import { lastVisitedLocation } from "../../lib/urls";
import { Backdrop } from "../Backdrop";
import { Box } from "../Box";
import { Icon } from "../Icon";
import { Text } from "../Text";
import { SettingsSidebar } from "./SettingsSidebar";

const Content = styled("div")`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
`;

const TenantBadge = styled("span")`
  margin-left: 8px;
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 0 8px 0 6px;
  height: 20px;
  background: var(--alpha4);
  border-radius: 38px;
  color: var(--text-secondary);
`;

type Props = {
  children: React.ReactNode;
};

export function SettingsLayout({ children }: Props) {
  const from = lastVisitedLocation(
    (url) => !url.startsWith("/settings") && !isAdminViewUrl(url)
  );
  const appOrigin = apiUrl();
  const appHost = (() => {
    try {
      return new URL(appOrigin).hostname;
    } catch {
      return appOrigin;
    }
  })();

  return (
    <>
      <title>{`Settings • ${config.title}`}</title>
      <Backdrop
        permanentNavigation
        overrideLogo={<Icon name="arrow-left" size={16} />}
        logoHref={from ?? "/"}
        navigation={<SettingsSidebar />}
        afterPath={
          <>
            <Box horizontal={4} vertical={8} center>
              <Text variant="text-regular-md">Settings</Text>
            </Box>
            <TenantBadge>
              <Icon name="building-2" size={10} />
              <Text variant="text-small-md" ellipsis style={{ maxWidth: 220 }}>
                {appHost}
              </Text>
            </TenantBadge>
          </>
        }
      >
        <Content>{children}</Content>
      </Backdrop>
    </>
  );
}
